import { mittInstance } from '@/constants/mitt-instance';
import { useUserContext } from '@/context/user';
import { GET_ACCOUNT_CHIP } from '@/typed-graphql/query';
import { useQuery } from '@apollo/client';
import { useEffect } from 'react';

const SyncUserInfo = () => {
  const [
    { isSignedIn },
    {
      actions: { setCurrentUser },
    },
  ] = useUserContext();

  const { refetch } = useQuery(GET_ACCOUNT_CHIP, {
    fetchPolicy: 'cache-and-network',
    skip: !isSignedIn,
    onCompleted(data) {
      const customer = data?.customer;

      if (!customer) return;

      setCurrentUser({
        email: customer.email || '',
        firstname: customer.firstname || '',
        lastname: customer.lastname || '',
      });
    },
  });

  useEffect(() => {
    const handler = () => {
      refetch().then(({ data }) => {
        const customer = data?.customer;

        if (!customer) return;

        setCurrentUser({
          email: customer.email || '',
          firstname: customer.firstname || '',
          lastname: customer.lastname || '',
        });
      });
    };

    mittInstance.on('REFRESH_CURRENT_USER_INFO', handler);

    return () => {
      mittInstance.off('REFRESH_CURRENT_USER_INFO', handler);
    };
  }, [refetch, setCurrentUser]);

  return null;
};

export default SyncUserInfo;
